import React from 'react'

import MarkdownEditor from '../../../../../../packages/kiti-editor/components/markdown/MarkdownEditor'

/**
 * Editor rico da Descrição (o mesmo `MarkdownEditor` de "criar nova atividade"), com um ajuste: o Slate dispara
 * `onChange` também ao só clicar/focar no editor, e o serializer devolve "\n" para um editor vazio. Aqui um valor
 * em branco volta como `undefined`, para o campo continuar "sem valor" (e portanto NÃO alterar a descrição da
 * atividade) enquanto ninguém digitar nada. O valor salvo continua sendo uma string, como antes.
 */
const DescriptionEditor = ({ onChange, ...props }) => (
  <MarkdownEditor {...props} onChange={value => onChange(value && value.trim() ? value : undefined)} />
)

export default DescriptionEditor
